module.exports = __webpack_public_path__ + "static/img/statistics_active.1b66bc13.png";